import swal from "sweetalert2";
import { Methods } from "../../shared/methods";
import { Component, OnInit } from "@angular/core";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { CompanyService } from "src/app/services/company.service";
declare var $: any;

@Component({
  selector: "app-companytype",
  templateUrl: "./companytype.component.html",
  styleUrls: ["./companytype.component.css"],
})
export class CompanytypeComponent implements OnInit {
  public mtds: Methods = new Methods();
  public loading = false;
  public data: DinamicData = new DinamicData(["Id", "Name", "Actions"]);
  public name;

  constructor(
    private _router: Router,
    private _companyService: CompanyService
  ) {}

  ngOnInit() {
    this.getList();

    $("#modalcompany").on("hidden.bs.modal", function () {
      this.method = { name: "" };
    });
  }

  getList() {
    this.loading = true;
    this._companyService.showAll().subscribe(
      (r) => {
        console.log(r);

        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.data.rows = [];

          for (let element of r.data) {
            const actionButtons = [
              {
                icon: "remove_red_eye",
                action: "Detail",
                color: "info",
                value: JSON.stringify({
                  id: element.id,
                  name: element.name,
                  points: element.points,
                  tare: element.tare,
                }),
              },
              // { icon: 'print', action: 'Print', color: 'primary' },
              {
                icon: "delete_outline",
                action: "Remove",
                color: "danger",
                value: JSON.stringify({
                  id: element.id,
                  name: element.name,
                  points: element.points,
                  tare: element.tare,
                }),
              },
            ];
            this.data.rows.push([
              new Cell(element.id),
              new Cell(element.name),
              new Cell(actionButtons, { type: "actions" }),
            ]);
          }
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  action(e) {
    console.log(e);
    switch (e.action) {
      case "Detail":
        this.modal(JSON.parse(e.id));
        break;
      case "Create":
        this.modal({ id: null, name: "" });
        break;
      case "Remove":
        this.remove(JSON.parse(e.id));
        break;

      default:
        break;
    }
  }

  public method = { id: null, name: "", points: 0, tare: 0.0 };

  modal(element) {
    this.method = element;
    $("#modalcompany ").appendTo("body").modal("show");
  }

  closeModal() {
    $("#modalcompany ").modal("hide");
  }

  public saving = false;
  save() {
    this.saving = true;
    this._companyService.create({ name: this.name }).subscribe(
      (r) => {
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.getList();
          this.closeModal();

          swal.fire({
            title: "Done!",
            text: `Changes have been successfully saved`,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.name = "";
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.saving = false;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  remove(element) {
    swal
      .fire({
        title: "Remove Container Type",
        text: `Are you sure to remove ${element.name} type?`,
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        buttonsStyling: false,
      })
      .then((request) => {
        if (request.value) {
          this._companyService.delete(element.id).subscribe(
            (r) => {
              if (r.code === 400 && r.msg === "Authorization not valid") {
                this.mtds.notifyError("Your session has expired");
                localStorage.clear();
                this._router.navigate(["/pages/lock"]);
              } else if (r.status === "success") {
                this.getList();
                swal.fire({
                  title: "Done!",
                  text: `${element.name} type has been successfully removed`,
                  buttonsStyling: false,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              } else {
                this.mtds.notifyError(r.msg, r.code);
              }
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
        }
      });
  }
}
